const ItalyFlag = () => (
  <svg viewBox="0 0 60 40" aria-hidden="true" className="lang-flag">
    <rect width="20" height="40" fill="#008C45" />
    <rect x="20" width="20" height="40" fill="#F4F5F0" />
    <rect x="40" width="20" height="40" fill="#CD212A" />
  </svg>
);

const UkFlag = () => (
  <svg viewBox="0 0 60 40" aria-hidden="true" className="lang-flag">
    <rect width="60" height="40" fill="#012169" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#F4F5F0" strokeWidth="8" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="4" />
    <path d="M30,0 V40 M0,20 H60" stroke="#F4F5F0" strokeWidth="13" />
    <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="7" />
  </svg>
);

export const LanguageToggle = ({ lang, onChange, strings }) => (
  <div className="lang-toggle" role="group" aria-label={strings.languageLabel} data-testid="language-toggle">
    <button type="button" className={`lang-option ${lang === "it" ? "is-active" : ""}`} aria-pressed={lang === "it"} title={strings.switchToItalian} onClick={() => onChange("it")} data-testid="language-it">
      <ItalyFlag /> <span>IT</span>
    </button>
    <button type="button" className={`lang-option ${lang === "en" ? "is-active" : ""}`} aria-pressed={lang === "en"} title={strings.switchToEnglish} onClick={() => onChange("en")} data-testid="language-en">
      <UkFlag /> <span>EN</span>
    </button>
  </div>
);

export default LanguageToggle;
